import { LoadingDialogContext } from '@/providers/loading-dialogs';
import { useContext } from 'react';

export function useLoadingDialog() {
    return useContext(LoadingDialogContext);
}
